/**
 * Remap deprecated API hostname so stale env vars still hit the live PocketBase host.
 * Duplicated in `src/setupProxy.js` (plain Node; cannot import this module there).
 */
export function normalizeUudServerUrl(url) {
  const s = String(url || "").trim().replace(/\/$/, "");
  if (!s) return s;
  try {
    const href = /^https?:\/\//i.test(s) ? s : `https://${s}`;
    const u = new URL(href);
    if (u.hostname.toLowerCase() === "pb2.uud.io") {
      u.hostname = "pb02.uud.io";
      return u.origin.replace(/\/$/, "");
    }
  } catch {
    /* ignore */
  }
  return s;
}
